<template>
    <div class="content-container">
        <div class="header">
            <div class="title">Topics</div>
        </div>        
        <div class="content">            
            <Preview v-for="topic in topics" :topic="topic" :key="topic.topicID"></Preview>            
        </div>
    </div>
</template>

<script>

    import api from '../../api/api'
    import Preview from '../../components/Member/ProfileTopicListItem.vue'
    import dialogs from '../../modules/dialogs';

    export default {
        props: ['memberID'],
        components: {
            Preview,
        },
        data() {
            return {
                topics: [],
            }
        },
        mounted() {
            api.get('/members/' + this.memberID + '/profile/topics')
                .then((response) => {
                    this.topics = response.data.topicList;
                }).catch(async (error) => {
                    await dialogs.alertAsync(error);
                });
        }
    }

</script>